import { useMemo } from "react";
import Icon, { ICON_NAME } from "../../../components/Icon";
import { datetime } from "../../../util/library/datetime";
import { ISite } from "../../../util/varibles/interface";
import styles from "./style.module.scss";
interface IProps {
    site: ISite
    height: number
}

const Starving: React.FC<IProps> = ({ site, height }) => {
    const { starvings = [] } = site;
    const list = useMemo(() => {
        const rs: { [time: string]: string[] } = {};
        starvings.forEach(s => {
            const { timestamp, starving_days, unit_id = "" } = s
            const key = datetime(timestamp).startOf('day').time;
            rs[key] = [...rs[key] || [], unit_id];
            for (let i = 1; i < starving_days; i++) {
                const key2 = datetime(timestamp).add(i, 'day').startOf('day').time;
                rs[key2] = [...rs[key2] || [], unit_id];
            }
        })
        return rs;
    }, [starvings])

    return <>
        {Object.keys(list).map(key => {
            const name = list[key].join(', ');
            return <span key={key} className={styles.starving} style={{ '--starving-left': key, top: `${-height}px` } as any} title={name}>
                < Icon className="mb-[-3px] mr-[2px]" icon={ICON_NAME.STARVING} size="large" />
                <span>{name}</span>
            </span >
        })}
    </>
}
export default Starving;